/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard  from './components/vx-card/VxCard.vue'
import VxList  from './components/vx-list/VxList.vue'
import VxBreadcrumb  from './layouts/components/VxBreadcrumb.vue'
import FeatherIcon  from './components/FeatherIcon.vue'
import VxInputGroup  from './components/vx-input-group/VxInputGroup.vue'
import AppIcon from './components/default/AppIcon.vue'
import AppSkeletonList from './components/default/AppSkeletonList.vue'
import AppEmptyState from './components/default/AppEmptyState.vue'
import AppKanbanColumnHeader from './components/default/AppKanbanColumnHeader.vue'
import FiltroPeriodoBadges from './components/default/FiltroPeriodoBadges.vue'
import FiltroDropdownGenerico from './components/default/FiltroDropdownGenerico.vue'
import FormaPagamentoBadge from './components/default/FormaPagamentoBadge.vue'
import AppInputTelefone from './components/default/AppInputTelefone.vue'
import ImageLightboxModal from './components/default/ImageLightboxModal.vue'

Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxCard.name, VxCard)
Vue.component(VxList.name, VxList)
Vue.component(VxBreadcrumb.name, VxBreadcrumb)
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(VxInputGroup.name, VxInputGroup)
Vue.component('AppIcon', AppIcon)
Vue.component('app-icon', AppIcon)
Vue.component('AppSkeletonList', AppSkeletonList)
Vue.component('app-skeleton-list', AppSkeletonList)
Vue.component('AppEmptyState', AppEmptyState)
Vue.component('app-empty-state', AppEmptyState)
Vue.component('AppKanbanColumnHeader', AppKanbanColumnHeader)
Vue.component('app-kanban-column-header', AppKanbanColumnHeader)
Vue.component('FiltroPeriodoBadges', FiltroPeriodoBadges)
Vue.component('filtro-periodo-badges', FiltroPeriodoBadges)
Vue.component('FiltroDropdownGenerico', FiltroDropdownGenerico)
Vue.component('filtro-dropdown-generico', FiltroDropdownGenerico)
Vue.component('FormaPagamentoBadge', FormaPagamentoBadge)
Vue.component('forma-pagamento-badge', FormaPagamentoBadge)
Vue.component('AppInputTelefone', AppInputTelefone)
Vue.component('app-input-telefone', AppInputTelefone)
Vue.component('ImageLightboxModal', ImageLightboxModal)
Vue.component('image-lightbox-modal', ImageLightboxModal)


// v-select component
import vSelect from 'vue-select'

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'XIcon',
        svgClasses: 'w-4 h-4 mt-1'
      }
    }),
  },
  OpenIndicator: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'ChevronDownIcon',
        svgClasses: 'w-5 h-5'
      }
    }),
  },
});

Vue.component(vSelect)
